import React from 'react';
import {Dropdown} from 'react-bootstrap';
import {Icons} from '../../icons/icons';
import {SvgIcon} from '../../icons/svgIcon';
import {SearchExportFormat} from '../search-types';
import './exportDropdownComponent.scss';
import {useTranslation} from 'react-i18next';
import {ExportToggles} from '../../config/config-types';
import {VerticalSeparator} from '../../common/verticalSeparator/verticalSeparator';


type ReportDropdownInputProps = {
    onSelect,
    exportToggles: ExportToggles
}

interface Option {
    value: SearchExportFormat;
    text: string;
}

const options: Option[] = [
    {value: SearchExportFormat.HTML, text: 'search.export.html'},
    {value: SearchExportFormat.JSON, text: 'search.export.json'}
];

export const ReportDropdown = React.memo((props: ReportDropdownInputProps) => {
    const {t} = useTranslation();

    const enabledExportOptions: Option[] = options.filter((element) => props.exportToggles[element.value]);

    return (
        <div id="export-wrapper">
            <VerticalSeparator/>
            <Dropdown id="export-dropdown">
                <Dropdown.Toggle id="export-dropdown-toggle">
                    <SvgIcon icon={Icons.EXPORT} id="icon-export"/>
                </Dropdown.Toggle>
                <Dropdown.Menu id="export-menu">
                    {enabledExportOptions.map(({value, text}) => (
                        <Dropdown.Item key={value} onClick={() => props.onSelect(value)}>{t(text)}</Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
});
